import "./index.scss";
import ReCAPTCHA from "react-google-recaptcha";

interface IProps {
  callback: (token: string | null) => void;
}

function GoogleRecaptchaComponent({ callback }: IProps) {
  const onChange = (value: string | null) => {
    callback(value);
  };

  return (
    <div className="GoogleRecaptchaStyle">
      <ReCAPTCHA
        sitekey="6Le2KzkjAAAAALEnJbBXfKDtR6lmRpD-yvJznxQm"
        onChange={onChange}
      />
    </div>
  );
}

export default GoogleRecaptchaComponent;
